export function formatAsCurrency({ amountInCents, currency }) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  }).format((amountInCents / 100).toFixed(2))
}

export function formatAsDisplayDate(date) {
  return new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date)
}

export function formatNumber(amount) {
  return new Intl.NumberFormat().format(amount)
}

export function formatCreditAmount(amount) {
  return `${formatNumber(amount)} credit${amount === 1 ? '' : 's'}`
}
